(() => {
  if (window.__dlCropSavingResetSep15) return;
  window.__dlCropSavingResetSep15 = true;

  function reset(root) {
    const crop = root?.querySelector?.('.dl-crop');
    const apply = crop?.querySelector?.('.dl-crop-apply');
    if (!apply) return;
    apply.disabled = false;
    apply.textContent = 'APPLY CROP';
  }

  document.addEventListener('click', event => {
    const open = event.target?.closest?.('[data-crop]');
    if (open) {
      const root = open.closest('.dl');
      requestAnimationFrame(() => reset(root));
      setTimeout(() => reset(root), 80);
      return;
    }
    const close = event.target?.closest?.('.dl-crop-cancel,.dl-crop-close');
    if (close) {
      const root = close.closest('.dl');
      requestAnimationFrame(() => reset(root));
    }
  }, true);

  window.addEventListener('droplit:image-selected', () => {
    document.querySelectorAll('.dl').forEach(reset);
  });
})();
